<template>
  <div class="account">
    <div class="account-bg"></div>
    <div class="register-welcome">欢迎加入文雅慕课</div>
    <custom-input type="mobile" rules="mobile" @validate="handleValid" v-model="mobile"></custom-input>
    <custom-input type="code" rules="code" @validate="handleValid" :mobile="mobile" v-model="code" codeType="regist" @getCode-click="sendMobileBtn"></custom-input>
    <custom-input type="password" rules="password" placeholder="请输入8-16位混合密码" @validate="handleValid" v-model="password"></custom-input>
    <div style="font-size: 0.33rem;color:#B93421;width: 90%;margin: 0.3rem auto 0;">
      注:密码8-16位，至少包含数字，字母，特殊符号(下划线除外)两种元素
    </div>
    <custom-input type="password" rules="password" placeholder="请确认密码" @validate="handleValid" v-model="passwordConfirm"></custom-input>
    <div class="register-confirm"><div class="register-check"></div>我已阅读并同意<span  @click="$router.push('/portal/login/protocol')">《服务条约》</span></div>
    <div class="register-login">已有账号？<span @click="$router.push('/login')">去登陆</span></div>
    <div class="account-button" @click="register">注册</div>
    <account-dialog :isOpen="isDialogShow" @close="isDialogShow=false" :textArr="error"></account-dialog>
    <!--人机验证-->
    <div id="captcha"></div>
  </div>
</template>

<script>
  import "@/asset/css/account.css";
  import {dtCheck} from "../../util/dt-checkbox";
  import { JSEncrypt } from 'jsencrypt';
  import  $  from 'jquery';
  document.write("<script type='text/javascript' src=" + "'" + window.location.protocol +
    "//bundle-static.chaoxing.com/cxsrl/js/jquery/jquery-3.7.1.min.js"
    +  "'><\/script>"
  );
  document.write("<script type='text/javascript' src=" + "'" + window.location.protocol +
    "//captcha.chaoxing.com/load.min.js?t="
    + parseInt(Date.now() / 60000) + "'><\/script>"
  );
  export default {
    name: "register",
    data(){
      return{
        error:[],
        isDialogShow:false,
        mobile:"",
        password:"",
        passwordConfirm:"",
        code:"",
        agree:false,
        pwd_public_key:'-----BEGIN PUBLIC KEY-----\n' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1ei9lsraicRarKVzFX8c\n' +
          'gEHRi2lwdupu/q9gJP2TUCFa+Gx5+fmcxZmCfDBJFweSFiRlxMQbBWSv686jeRmz\n' +
          'inK/zj8OhUdN7NHrjojDHu7atyK3ZzL+nHs4l4y2rFdeAPRkSr4RavfjLksh4H/k\n' +
          'w7exAMkfJ/OR5Xjt9Izc5YYl6HNmPv4hwDF114N96Ns1HrTgCOsLOiG0VA8z47v/\n' +
          'iZt864XBKg33SVzh7A4PL6N6Yiwj9m1ag6iJqZjYgcaK0oFZjUk8OY9a9S4seGTG\n' +
          'fp71jcW0+gDJ8EG0phadxp0AxCWzCay0MCjhry7y2P//49fjbmWWlnj1OIB06E3f\n' +
          'jwIDAQAB\n' +
          '-----END PUBLIC KEY-----',
        phoneReg:/^[0-9]{11}$/,//手机号验证规则
        captchaIns:null,//超盾
        flagCapt:true,
      }
    },
    created() {

    },
    methods:{
      register(){
        var that = this;
        //遍历所有子组件，验证其中的custom-input组件
        this.error=[];
        this.$children.forEach((value,index)=>{
          if(value.$options.name=="custom-input"){
            value.validate();
          }
        })
        var encrypt = new JSEncrypt();
        encrypt.setPublicKey(that.pwd_public_key);
        var timestamp = (Date.parse(new Date()) / 1000).toString();
        var dat = {
          mobile: that.mobile,
          password: that.password,
          confirm_psd: that.passwordConfirm,
          verify_code: that.code,
          agreement:$('.register-check').hasClass('register-check-checked')?1:0,
          timestamp:timestamp
        };
        dat = JSON.stringify(dat);
        var sendData = encrypt.encrypt(dat);
        if(this.error.length>0){
          this.isDialogShow=true;
        } else{
          $.ajax({
            url: '/api/proxy/index',
            data: {
              api:'/v1/passport/platform_register',
              data:sendData,
              center_id:that.tools.getStorage("center_id") || ""
            },
            dataType: 'json',
            type: 'post',
            success:function(res){
              if(res.status===1){
                that.$toast("注册成功");
                window.setTimeout(()=>{
                  that.$router.push("/login");
                },1000);
              }else{
                that.$toast(res.msg);
              }
            }
          })
          // this.$api.post("",{
          //   // api:"/v1/passport/register",
          //   api:"/v1/passport/platform_register",
          //   data:sendData,
          //   center_id:this.tools.getStorage("center_id") || ""
          //   // mobile:this.mobile,
          //   // password:this.password,
          //   // confirm_psd:this.passwordConfirm,
          //   // verify_code:this.code,
          //   // agreement:this.agree?1:0,
          // },res=>{
          //   if(res.status===1){
          //     this.$toast("注册成功");
          //     window.setTimeout(()=>{
          //       this.$router.push("/login");
          //     },1000);
          //   }
          // })
        }
      },
      handleValid(obj){
        if(!obj.result){
          this.error.push(obj.msg);
        }
      },
      getcode(validate){
        var that = this
        var mobile = this.mobile
        // 发起请求
        $.ajax({
          type: 'post',
          url: '/api/proxy/index',
          dataType: 'json', // 用来约束服务器返回的数据类型
          data: {api:'/v1/code/mobile',mobile: mobile, type: 'regist', validate: validate},
          // timeout: 2000, // 设置超时
          beforeSend: function () {
          },
          success: function (res) {
            if (res.status == 1) {
              var ses = 60;
              that.flagCapt = false;
              var t = setInterval(function () {
                $('#verification-btn').html(ses-- + '秒后重新获取')
                  .addClass('disabled');

                if (ses < 0) {
                  clearInterval(t);
                  $('#verification-btn').html('获取验证码')
                    .removeClass('disabled');
                  that.flagCapt = true;
                }
              }, 1000);
            } else {
              that.$toast(res.msg);
            }
          }
        });
      },
      sendMobileBtn(){
        if(this.flagCapt==false){
          return false;
        }
        // 校验参数
        var phoneNumberVal = this.mobile;
        if (!phoneNumberVal) {
          this.$toast("请输入手机号");
          return false;
        }else if (!this.phoneReg.test(this.mobile)) {
          this.$toast('请输入正确的手机号！');
          return false;
        };
        this.captchaIns && this.captchaIns.popUp();
      }
    },
    mounted(){
      //自定义复选框
      this.agree=dtCheck({
        el:document.querySelector(".register-check"),
        className:"register-check-checked"
      });
      var that = this;
      setTimeout(function(){
        initCXCaptcha({
          captchaId:'y3G8jMGuIly3H68H86pKWwUTom4QLwb0',
          element:'#captcha',
          mode:'popup',
          type: 'slide',
          onVerify: function (err, data) {
            if (err) return; // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
            that.getcode(data.validate);
            that.captchaIns.refresh();
          }
        },function onload(instance){
          that.captchaIns = instance;
        },function onerror(err){
          console.log(err)
        });
      },1000)
    }
  }
</script>

<style scoped>
  .register-welcome{
    margin-top:0.24rem;
    font-size:0.507rem;
    line-height:0.507rem;
    color:#333;
    text-align: center;
    font-weight:bold;
  }
  .register-check{
    display: inline-block;
    width:0.293rem;
    height:0.293rem;
    margin-right:0.147rem;
    border:1px solid #999;
    border-radius: 2px;
  }
  .register-check-checked{
    background:url("../../asset/img/account/selected.png") center center no-repeat;
    background-size:0.253rem;
  }
  .register-confirm{
    margin:0.533rem 0.4rem 0 0.4rem;
    color:#0c539b;
    font-size:0.373rem;
  }
  .register-login{
    margin-top:3.6rem;
    text-align: center;
    color:#999;
  }
  .register-login span{
    color:#0c539b;
  }
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue